import getMTRegex from "./getMTRegex";
import { IMergeTag, IMergeTagArray } from "../../../types/MergeTags";

type MergeTagSyntax = { start: string; end: string };

/**
 * True when `value` is a whole merge tag and nothing else.
 *
 * getMTRegex returns an unanchored pattern, so it also matches a tag embedded
 * in surrounding text. Anchoring is what makes this a "pure merge tag" check —
 * which is what a URL field needs, since an HTML snippet or a tag wrapped in
 * markup can never be a valid link target.
 */
export function isFullMergeTag(
  value: string,
  syntax?: MergeTagSyntax
): boolean {
  return new RegExp(`^${getMTRegex(syntax)}$`).test(value);
}

/** Grouped tree, keeping only whole merge tags and dropping emptied groups. */
export function filterFullMergeTags(
  items: IMergeTagArray,
  syntax?: MergeTagSyntax
): IMergeTagArray {
  const result: IMergeTagArray = [];

  items.forEach((item) => {
    if ("items" in item) {
      const filtered = filterFullMergeTags(item.items, syntax);
      if (filtered.length > 0) {
        result.push({ name: item.name, items: filtered });
      }
      return;
    }

    if (isFullMergeTag(item.value, syntax)) {
      result.push(item);
    }
  });

  return result;
}

/** Flat list counterpart, so the typing autocomplete cannot suggest a tag the dropdown refuses to show. */
export function filterFullMergeTagsFlat(
  items: IMergeTag[],
  syntax?: MergeTagSyntax
): IMergeTag[] {
  return items.filter((item) => isFullMergeTag(item.value, syntax));
}
